/**
 * RFC 4180-style CSV cell: quote field and double internal double-quotes.
 * Avoids JSON.stringify, which uses backslash escapes that break CSV parsers.
 */
export function escapeCsvField(value) {
  if (value === null || value === undefined) return '""';
  const s =
    typeof value === "object" ? JSON.stringify(value) : String(value);
  return `"${s.replace(/"/g, '""')}"`;
}

/** Join rows (each row is an array of raw values) into a CSV string with CRLF lines. */
export function rowsToCsv(rows) {
  return rows.map((row) => row.map(escapeCsvField).join(",")).join("\r\n");
}

/** Prefix for Excel and similar tools to detect UTF-8. */
export const UTF8_BOM = "\uFEFF";

export function downloadCsvBlob(filename, csvBody) {
  const blob = new Blob([UTF8_BOM + csvBody], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
